import { Fragment } from 'react'
import { PdfConfigPage, PdfConfigSection } from '../../types'
import PdfModulesRenderer from '../PdfModulesRenderer'
import usePdfRendererStyles from '../usePdfRendererStyles'

interface PdfA4RendererProps {
    page: PdfConfigPage,
}

const PdfA4Renderer: React.FC<PdfA4RendererProps> = ({ page }) => {
    const renderThis: JSX.Element[] = []

    for (const section of page.sections) {
        renderThis.push(<Section section={section} key={section.id} />)
    }

    return (
        <Fragment>
            {renderThis}
        </Fragment>
    )
}

interface SectionProps {
    section: PdfConfigSection
}

const Section: React.FC<SectionProps> = ({ section }) => {
    const renderThis: JSX.Element[] = []
    if (section.elements.length) {
        for (const element of section.elements) {
            renderThis.push(<PdfModulesRenderer mymodule={element} key={element.id} />)
        }
    }
    const { renderStyles } = usePdfRendererStyles()
    const myStylesRenderer = renderStyles(section.cssConfig)

    return (
        <div className='flex pdf_section' style={myStylesRenderer}>
            {renderThis}
        </div>
    )
}


export default PdfA4Renderer